module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"cs":{"CartInfo":{"titleScreenReader":"Obsah košíku"}},"en":{"CartInfo":{"titleScreenReader":"Cart total"}}}')
  delete Component.options._Ctor
}
